import React, { FC, Fragment } from "react";

import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

export const RemovalBuildingOccupationConfirmationForm: FC = () => {
    const classes = useStyles();

    const { values, setValues } =
        useFormModel<ChangeNames.REMOVAL_BUILDING_OCCUPATION_CONFIRMATION>();

    return (
        <div style={{ marginTop: 32 }}>
            <h4 className={classes.h4}>Bestätigung</h4>
            <FormControlLabel
                isCheckBox={true}
                style={{ marginBottom: 20 }}
                label="Ich versichere, dass zum Zeitpunkt der Demontage das Gebäude nicht mehr genutzt wird."
                labelPlacement="end"
                control={
                    <Fragment>
                        <Checkbox
                            value="ja"
                            checked={values.removalBuildingOccupationConfirmation.value.yes}
                            onChange={(event, checked) => {
                                setValues((values) => {
                                    values.removalBuildingOccupationConfirmation.value = {
                                        yes: checked,
                                        no: !checked,
                                    };
                                });
                            }}
                        />
                    </Fragment>
                }
                error={values.removalBuildingOccupationConfirmation.error !== null}
            />
        </div>
    );
};
